"use client";

import React from 'react';
import Breadcrumbs from './Breadcrumbs';

interface BreadcrumbsWrapperProps {
  homeLabel?: string;
  omitCurrent?: boolean;
  className?: string;
}

/**
 * BreadcrumbsWrapper component
 * 
 * A standardized wrapper for breadcrumbs to ensure consistent 
 * placement and styling across all pages.
 * Positions breadcrumbs as a thin layer between hero content and main content.
 */
const BreadcrumbsWrapper: React.FC<BreadcrumbsWrapperProps> = ({
  homeLabel,
  omitCurrent = false,
  className = "",
}) => {
  return (
    <div className="w-full bg-gray-50 py-2">
      <div className="container mx-auto px-4">
        <Breadcrumbs 
          homeLabel={homeLabel}
          omitCurrent={omitCurrent}
          className={`text-sm ${className}`}
        />
      </div>
    </div>
  );
};

export default BreadcrumbsWrapper;